import { render } from "./DetalharPartidaModal.vue?vue&type=template&id=c6206926&scoped=true"
import script from "./DetalharPartidaModal.vue?vue&type=script&lang=js"
export * from "./DetalharPartidaModal.vue?vue&type=script&lang=js"

import "./DetalharPartidaModal.vue?vue&type=style&index=0&id=c6206926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6206926"]])

export default __exports__